import styled from "styled-components";

export const Wrapper = styled.div`
    transform-origin: top left;
    background-color: ${p => p.theme.c.snowOnActive};
`;

export const Pagination = styled.div`
    height: 50px;
    text-align: center;
`;
